// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1_U3W","title":"ClientInsurance_title__1yEC9","itemText":"ClientInsurance_itemText__33AqE"};